module.exports = __webpack_public_path__ + "static/img/comfirBtnGazh-tw.de60911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/comfirBtnGazh-tw.png
// module id = Vrwc
// module chunks = 1